import FavouriteButton from './FavouriteButton';
import FavouriteButtonContainer from './FavouriteButton.container';
export default FavouriteButtonContainer(FavouriteButton);
